/**
 * Maybe improve tonality list in future?
 * Hints:
 * - https://en.wikipedia.org/wiki/Key_signature_names_and_translations
 * - https://www.musiccrashcourses.com/lessons/key_relationships.html
 */

import { ValueAndLabel } from "../../items/item/SelectGraphQlMutate";

export const tonalities: ValueAndLabel[] = [
  { value: "C / a (kein Vorzeichen)", label: "C / a (kein Vorzeichen)" },
  { value: "G / e (1♯)", label: "G / e (1♯)" },
  { value: "D / h (2♯)", label: "D / h (2♯)" },
  { value: "A / fis (3♯)", label: "A / fis (3♯)" },
  { value: "E / cis (4♯)", label: "E / cis (4♯)" },
  { value: "H / gis (5♯)", label: "H / gis (5♯)" },
  { value: "Fis / dis (6♯)", label: "Fis / dis (6♯)" },
  { value: "Cis / ais (7♯)", label: "Cis / ais (7♯)" },
  { value: "F / d (1♭)", label: "F / d (1♭)" },
  { value: "B / g (2♭)", label: "B / g (2♭)" },
  { value: "Es / c (3♭)", label: "Es / c (3♭)" },
  { value: "As / f (4♭)", label: "As / f (4♭)" },
  { value: "Des / b (5♭)", label: "Des / b (5♭)" },
  { value: "Ges / es (6♭)", label: "Ges / es (6♭)" },
  { value: "Ces / as (7♭)", label: "Ces / as (7♭)" },
] as const;
